import React, { useState } from "react";
import { Constants } from "../../CommonMethhods/Constants";
import ReportTableHeader from "./ReportTableHeader";

function LeviesReportTable(props) {
  let gridVal = props.gridVal;

  const showLeviesData = (gridVal) => {
    return (
      gridVal &&
      gridVal.map((item, key) => {
        return (
          <tr key={key}>
            <td>{item.scrip === "" || undefined || null ? "-" : item.scrip}</td>
            <td>
              {item.saudaDate === "" || undefined || null
                ? "-"
                : item.saudaDate}
            </td>
            {props.seg === "fo" ? (
              <td>
              {item.futBrokerage === "" || undefined || null
                ? "-"
                : item.futBrokerage}
            </td>)
            :
            (
            <td>
              {item.brokerage === "" || undefined || null
                ? "-"
                : item.brokerage}
            </td>
            )
          }
          {props.seg === "fo" &&(
            <td>
            {item.optBrokerage === "" || undefined || null
              ? "-"
              : item.optBrokerage}
          </td>
          )}
            <td>{item.gst === "" || undefined || null ? "-" : item.gst}</td>
            {props.seg === "fo" ? (
              <td>
                {item.sttChrg === "" || undefined || null ? "-" : item.sttChrg}
              </td>
            ) : (
              <td>{item.stt === "" || undefined || null ? "-" : item.stt}</td>
            )}

            <td>
              {item.stampDuty === "" || undefined || null
                ? "-"
                : item.stampDuty}
            </td>
            <td>
              {item.sebiTax === "" || undefined || null ? "-" : item.sebiTax}
            </td>
            {props.seg === "fo" ? (
              <td>
                {item.futTurnTax === "" || undefined || null
                  ? "-"
                  : item.futTurnTax}
              </td>
            ) : (
              <td>
                {item.turnTax === "" || undefined || null ? "-" : item.turnTax}
              </td>
            )}
            {props.seg === "fo" && (
              <td>
                {item.optTurnTax === "" || undefined || null
                  ? "-"
                  : item.optTurnTax}
              </td>
            )}

            <td>
              {item.otherCharges === "" || undefined || null
                ? "-"
                : item.otherCharges}
            </td>
            <td>
              {item.totalCharges === "" || undefined || null
                ? "-"
                : item.totalCharges}
            </td>
          </tr>
        );
      })
    );
  };

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper">
        {gridVal && gridVal.length > 0 ? (
          <table className="table last-column">
            <thead>
              <tr>
                {/* {Object.keys(gridVal[0]).map((value, index) => {
                  return (
                    <th key={index} className="snapshot-table-column">
                      {value}
                    </th>
                  );
                })} */}
                <th scope="col">{Constants.Scrip}</th>
                <th scope="col" className="text-center">
                  {Constants.Sauda_Date}
                </th>
                {props.seg === "fo" ?
                <th scope="col" className="text-center">
                  Fut Brokerage
                </th>
                : <th scope="col" className="text-center">
                  Brokerage
                </th>
                }
                {props.seg === "fo" && 
                  <th scope="col" className="text-center">
                    Opt Brokerage
                  </th>
                }
                <th scope="col" className="text-center">
                  {Constants.Gst}
                </th>
                <th scope="col" className="text-center">
                  {Constants.STT}
                </th>
                <th scope="col" className="text-center">
                  {Constants.Stamp_Duty}
                </th>
                <th scope="col" className="text-center">
                  {Constants.Sebi_Tax}
                </th>
                {props.seg === "fo" ?
                <th scope="col" className="text-center">
                  Fut Turn TAX
                </th>
                :
                <th scope="col" className="text-center">
                  {Constants.Turn_Tax}
                </th>
                }
                
                {props.seg === "fo" && 
                  <th scope="col" className="text-center">
                    Opt Turn TAX
                  </th>
                }
                <th scope="col" className="text-center">
                  {Constants.Other_Charges}
                </th>
                <th scope="col" className="text-center">
                  {Constants.Total_Charges}
                </th>
              </tr>
            </thead>
            <tbody>{showLeviesData(gridVal)}</tbody>
          </table>
        ) : (
          <div className="report-error-message">
            {Constants.Levies_Report_doesnt_exist}
          </div>
        )}
      </div>
    </>
  );
}
export default LeviesReportTable;
